import { define } from 'wicked-elements'
import { bus } from '../../bus.js'

define('[data-map-click]', {
  init () {
    this.children = [...this.element.querySelectorAll('[data-uuid]')]
    this.handleClick = this.handleClick.bind(this)
  },
  connected () {
    this.children.forEach(element => {
      element.addEventListener('click', this.handleClick)
    });
  },
  disconnected () {
    this.children.forEach(element => {
      element.removeEventListener('click', this.handleClick)
    });
  },
  handleClick (e) {
    const uuid = e.currentTarget?.dataset?.uuid?.trim()
    if (uuid) {
      bus.emit('map:setactive', [uuid])
      bus.emit('map:flyto', [uuid])
    }
  }
})